'use client'

import { ConfirmDialog } from '@repo/ui/ConfirmDialog'
import { createConfirmation } from '@repo/ui/ConfirmMountPoint'
import { confirmable } from 'react-confirm'

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
const confirmHOC = confirmable(ConfirmDialog)
export const confirmWithParams = createConfirmation(confirmHOC)

export function confirm(confirmation, options = {}) {
  return confirmWithParams({ confirmation, ...options })
}
